import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Company, CompanyEnum } from '../../models/company.model';
import { PriceListAccommodation } from '../../models/pricelist-accommodation.model';
import { PositivelyLanguagesAccommodationTableComponent } from './positively-languages-accommodation-table/positively-languages-accommodation-table.component';
import { AlpAccommodationTableComponent } from './alp-accommodation-table/alp-accommodation-table.component';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { NotesComponent } from '../notes/notes.component';
import { Note } from '../../models/types';
import { extractNotes } from '../../utils/pricelist.functions';
import { Currency } from '../../models/currency.model';

@Component({
  standalone: true,
  imports: [CommonModule, PositivelyLanguagesAccommodationTableComponent, AlpAccommodationTableComponent, TableHeaderComponent, NotesComponent],
  selector: 'lx-price-lists-portal-accommodation-table',
  templateUrl: './accommodation-table.component.html',
  styleUrls: ['./accommodation-table.component.scss'],
})
export class AccommodationTableComponent implements OnInit {
  @Input() accommodations: PriceListAccommodation | undefined;
  @Input() currency: Currency | undefined;
  @Input() company: Company = CompanyEnum.KIL;

  tableTitle = '';
  notes: Note[] = [];
  notationMarks: Record<string, string> | undefined;

  companyEnum = CompanyEnum;

  ngOnInit(): void {
    this.tableTitle = this.company === CompanyEnum.KIL ? 'Accommodation prices' : 'Accommodation';

    if (this.accommodations?.notes) {
      const noteCodesInProducts = this.accommodations.products
        .flatMap((product) => [product.noteCode, ...product.options.map((option) => option.noteCode)])
        .filter((noteCode) => noteCode !== null);
      [this.notes, this.notationMarks] = extractNotes(this.accommodations.notes, noteCodesInProducts);
    }
  }
}
